const $header = $('.header');
const $searchItem = $header.find('.nav-menu_item.nav-menu_item--search > a, .header-nav_search');
//const $socialItem = $header.find('.nav-menu_item.nav-menu_item--social > a');
//const $socialLinksItems = $header.find('.social-links_item');

export default function() {
    $(window).scroll(() =>  {
        let scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $header.addClass('header--scrolled');
        } else {
            $header.removeClass('header--scrolled');
        }
    });

    $searchItem.click(event =>  {
        event.preventDefault();

        $searchItem.closest('.nav-menu_item').toggleClass('nav-menu_item--active');
        if($(event.currentTarget).hasClass('header-nav_search'))
            $(event.currentTarget).toggleClass('header-nav_search--active');

        $('body').toggleClass('overflow-hidden');

        if ($('.to-blur').hasClass('to-blur--blured')) {
            $('.to-blur').removeClass('to-blur--blured');
            $('.search--fixed').fadeOut(500);
            $('.search--fixed').find('form')[0].reset();
        } else {
            $('.to-blur').addClass('to-blur--blured');
            $('.search--fixed').fadeIn(500);
            $('.search--fixed').find('.search_input').focus();
        }
    });

    /*$socialItem.click(event =>  {
        const $this = $(event.currentTarget);
        event.preventDefault();

        $this.closest('.nav-menu_item').toggleClass('nav-menu_item--active');
    });*/

    $(document).keydown(event => {
        // ESCAPE key pressed
        if (event.keyCode === 27) {
            if ($('.to-blur').hasClass('to-blur--blured')) {
                $('.to-blur').removeClass('to-blur--blured');
                $('.search--fixed').fadeOut(500, () =>  {
                    $('.search--fixed').find('form')[0].reset();
                });
                $('body').removeClass('overflow-hidden');
                $('.nav-menu_item--search').removeClass('nav-menu_item--active');
                $('.header-nav_search').removeClass('header-nav_search--active');
            }
        }
    });

    $('.hamburger, .header-nav_menu-close').click(event => {
        event.preventDefault();

        $('.hamburger').toggleClass('is-active');
        $('.header-nav_menu').toggleClass('is-visible');
    });

    /*$socialLinksItems.click(event => {
        let text = $(event.currentTarget).text();

        trackEvent(`${text} social link`, 'click', window.location.pathname);
    })*/
}
